import { Comments } from '../comments';
import { Distribution } from '../distribution';
import { Files } from '../files';

export class RightMail {
  annulerPriseEnCharge?: boolean;
  answerMail?: boolean;
  canArchive?: boolean;
  canDeleteMail?: boolean;
  cloturerPrendreEnCharge?: boolean;
  comment?: Comments;
  distribution?: Distribution;
  edit?: boolean;
  files?: Files;
  iCourrierWriteAuthorized?: boolean;
  markAPrendreEnCharge?: boolean;
  mauvaisRoutageMail?: boolean;
  pin?: boolean;
  prendreEnChargeCollaborative?: boolean;
  prendreEnChargeExclusive?: boolean;
  refuserPriseEnCharge?: boolean;
  validate?: boolean;
  viewDroits?: boolean;
  viewHistory?: boolean;

  constructor(data: Partial<RightMail>) {
    Object.assign(this, data);
  }
}
